module.exports = "https://s91588.cdn.ngenix.net/news-frontend/_next/static/images/cards-f98ad7612ca37a396a138246b4c5faa8.jpg";